/**
 * R7.2.2F4A — single deterministic camera glyph for Customer + Visual Search.
 * Never emoji / icon-font / CSS content — Telegram Android WebView mojibakes those.
 */
export function CameraTriggerIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      className="as-camera-trigger-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-camera-icon="svg"
    >
      <path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z" />
      <circle cx="12" cy="14" r="3.5" />
    </svg>
  );
}
